(function () {
  function getRootPath() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    } catch (e) {
      return '/';
    }
  }

  function fallbackMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var symbol = '';
    try { symbol = (window.currencySymbol || '').trim(); } catch (e) {}
    if (!symbol) symbol = 'Rs. ';
    try {
      return symbol + amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return symbol + amount.toFixed(2);
    }
  }

  function formatMoney(cents) {
    try {
      var fmt = window.money_format || (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, fmt);
      }
      return fallbackMoney(cents);
    } catch (e) {
      return fallbackMoney(cents);
    }
  }

  function openCartDrawerIfAvailable() {
    try { document.body.classList.add('cart-sidebar-show'); } catch (e) {}
  }

  function normalizeSelect(select) {
    if (!select || !select.options || !select.options.length) return;
    var opt = select.options[select.selectedIndex];
    var isDisabled = opt ? (opt.disabled || opt.hasAttribute('disabled')) : false;
    if (opt && !isDisabled) return;
    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      if (!(o.disabled || o.hasAttribute('disabled'))) {
        select.selectedIndex = i;
        break;
      }
    }
  }

  function syncAtcState(card, select) {
    if (!card) return;
    var btn = card.querySelector('[data-as-pc-atc]');
    if (!btn) return;
    if (select && select.options && select.options.length) {
      var opt = select.options[select.selectedIndex];
      btn.disabled = !!(opt && (opt.disabled || opt.hasAttribute('disabled')));
    }
  }

  function updateCardFromSelect(card, select) {
    if (!card || !select || !select.options || !select.options.length) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    var price = Number(opt.getAttribute('data-price') || 0);
    var compare = Number(opt.getAttribute('data-compare') || 0);

    var priceEl = card.querySelector('[data-as-pc-price]');
    var compareEl = card.querySelector('[data-as-pc-compare]');

    if (priceEl) priceEl.innerHTML = '<span class="money">' + formatMoney(price) + '</span>';
    if (compareEl) {
      if (compare > price) {
        compareEl.innerHTML = '<span class="money">' + formatMoney(compare) + '</span>';
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    try { card.setAttribute('data-as-pc-variant-id', select.value); } catch (err) {}
    syncAtcState(card, select);
  }

  // Ensure the default selected variant is never a disabled (sold out) option (common on iOS/select rendering)
  function initNormalizeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-as-pc-card] [data-as-pc-variant]').forEach(function (select) {
      normalizeSelect(select);
      var card = select.closest('[data-as-pc-card]');
      updateCardFromSelect(card, select);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNormalizeAll);
  } else {
    initNormalizeAll();
  }

  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest ? e.target.closest('[data-as-pc-variant]') : null;
    if (!select) return;

    var card = select.closest('[data-as-pc-card]');
    if (!card) return;

    normalizeSelect(select);

    updateCardFromSelect(card, select);
  });

  // If cards are injected after initial load (sliders, tabs, infinite scroll), normalize them too.
  try {
    var mo = new MutationObserver(function (mutList) {
      var nodesToInit = [];
      mutList.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if ((node.matches && node.matches('[data-as-pc-card]')) || (node.querySelector && node.querySelector('[data-as-pc-card]'))) {
            nodesToInit.push(node);
          }
        });
      });
      if (!nodesToInit.length) return;
      nodesToInit.forEach(function (n) { initNormalizeAll(n); });
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-as-pc-atc]') : null;
    if (!btn) return;
    if (btn.disabled) return;

    var card = btn.closest('[data-as-pc-card]');
    if (!card) return;

    var variantId = null;
    var select = card.querySelector('[data-as-pc-variant]');
    if (select) variantId = select.value;
    if (!variantId) variantId = card.getAttribute('data-as-pc-variant-id');
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-as-pc-loading-text') || 'Adding...';

    fetch(getRootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.as_cart_drawer && window.as_cart_drawer.enabled && window.as_cart_drawer.open_on_add_to_cart) {
          openCartDrawerIfAvailable();
        }

        if (window.Shopify && typeof Shopify.getCart === 'function') {
          Shopify.getCart(function (cart) {
            if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
              window.sharedFunctions.updateSidebarCart(cart);
            }
          });
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();

